import jump from "jump.js";
import Common from "../common/Common";

class SmoothScroll1 {
  constructor() {
    this.common = new Common();
    this.mediaQueryList = this.common.matchMedia("md");

    const links = document.querySelectorAll('a[href^="#"]');
    let offset = 0;
    let delay = 900;
    let click = true;

    links.forEach((link) => {
      link.addEventListener("click", (e) => {

        e.preventDefault();
        if( click ) {
          click = false;
          const href = e.currentTarget.getAttribute("href");
          const target = document.querySelector(href);
          const targetPos = target.getBoundingClientRect().top;
          const header = document.querySelector(".l-header");
          const headerH = header.offsetHeight;
          let otherH = 0;
          let frag = false;
          if( !header.classList.contains("is-hidden") ) {
            frag = true;
          }

          if (this.mediaQueryList.matches) {
            // pagenav3
            if( e.currentTarget.closest(".js-pagenav3") ) {
              const pagenav3H = e.currentTarget.closest(".js-pagenav3").offsetHeight;
              otherH = otherH + pagenav3H;
              //const items = e.currentTarget.closest(".js-pagenav3").querySelectorAll(".c-pagenav3__item1");
              //if( items.length < 3 && e.currentTarget.closest(".c-pagenav3__item1:first-child") ) {
              //  otherH = otherH - pagenav3H;
              //}
            }
          } else {
            // pagenav2
            if( document.querySelector('.js-pagenav2') && e.currentTarget.closest(".c-pagenav2, .c-pagenav3") ) {
              const pagenav2H = 60;
              const pagenav3H = 53;
              otherH = otherH + pagenav2H + pagenav3H;
            }
            //if( document.querySelector('.js-pagenav2.is-mdFixed1') ) {
            //  const pagenav2H = document.querySelector('.js-pagenav2.is-mdFixed1 .c-pagenav2__inner1').offsetHeight;
            //  const pagenav3H = document.querySelector('.js-pagenav2.is-mdFixed1 .c-pagenav2__link1.is-current1 + .c-pagenav3').offsetHeight;
            //  otherH = otherH + pagenav2H + pagenav3H;
            //}
          }

          if( frag ) {
            offset = - headerH - otherH;
          } else {
            offset = - otherH;
          }

          jump( target, {
            duration: 100,
            collback: headerFixed(),
            offset: offset,
          });

          function headerFixed() {
            if( frag ) {
              header.classList.add("is-show");
              setTimeout(() => {
                header.classList.remove("is-show", "is-hidden");
                click = true;
              }, delay);
            } else {
              header.classList.add("is-hide");
              setTimeout(() => {
                header.classList.remove("is-hide");
                if( href != "#pagetop" ) {
                  header.classList.add("is-hidden");
                }
                click = true;
              }, delay);
            }
          }
        }
      });
    });
  }
}

export default SmoothScroll1;
